import { render, staticRenderFns } from "./ManageAlertPage.vue?vue&type=template&id=12427a68&"
import script from "./ManageAlertPage.vue?vue&type=script&lang=js&"
export * from "./ManageAlertPage.vue?vue&type=script&lang=js&"
import style0 from "./ManageAlertPage.vue?vue&type=style&index=0&id=12427a68&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports